export default __webpack_public_path__ + "images/AutumnAnnouncementsBackground.web.png";